import stringify from 'json-stable-stringify';

export function mergeEntities(existingEntities, newEntities, entityKey) {
  let data = [...existingEntities || []];

  if (newEntities) {
    newEntities.forEach((ne) => {
      let isUpdate = false;
      data = data.map((existingEntity) => {
        if (existingEntity[entityKey] === ne[entityKey]) {
          isUpdate = true;
          return ne;
        }

        return existingEntity;
      });

      if (!isUpdate) {
        data.push(ne);
      }
    });
  }

  if (stringify(data) === stringify(existingEntities)) {
    return existingEntities;
  }

  return data;
}

/**
 * Merges the old entities to the new entities such that old entities that
 * are present in the new entities list and haven't mutated in the new entity
 * list will be retained but order of the items will be as per new entity list.
 * It will drop old entities not present in the new entities list.
 * Eg. When user clicks on Conversation expand, it loads
 * new activities in the thread but the clicked item
 * and its parents will need to not reload.
 *
 * @param {*} existingEntities, current entities present in the store
 * @param {*} newEntities, new entities list
 * @param {*} entityKey, entity key name Eg. 'id'
 * @returns new entities list with already existing entities unchanged.
 */

export function mergeToNewEntities(existingEntities, newEntities, entityKey) {
  let data = [...newEntities || []];

  if (existingEntities && existingEntities.length) {
    data = newEntities.map((newEntity) => {
      // Check if entity already exists and retain it if hasn't changed.
      // This is to preserve the existing Entity reference and avoid mutating/re-render the item.
      const existingEntity = existingEntities.find(entity =>
        (entity[entityKey] === newEntity[entityKey] &&
          stringify(entity) === stringify(newEntity)));

      return existingEntity || newEntity;
    });
  }

  return data;
}

export function updateEntity(entityCollection, entityId, diff, entityKey) {
  if (!entityCollection) {
    return entityCollection;
  }

  const itemIndex =
    entityCollection.findIndex(e => e[entityKey] === entityId);

  if (itemIndex === -1) {
    return entityCollection;
  }

  return entityCollection.map((existingEntity) => {
    if (existingEntity[entityKey] === entityId) {
      return { ...existingEntity, ...diff };
    }
    return existingEntity;
  });
}

export function deleteEntityWithPredicate(entityCollection, predicate) {
  if (!entityCollection) {
    return entityCollection;
  }

  const filteredOut = entityCollection.filter(e => !(predicate(e)));

  // No change return original entity.
  if (filteredOut.length === entityCollection.length) {
    return entityCollection;
  }

  return filteredOut;
}
